import React, { useState, useEffect } from 'react';
// import styles from './index.module.scss';
import './style.scss';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import { IAPIUserInfo } from '../../../model/api-modules';

import { formatEmailName } from '../../../lib/email';
import { EditPasswordModal } from '../components/edit-password-modal';
import { DeleteAccount } from './delete-account';
import { AccountInfo } from './info';
import { getUserInfo } from '../../../api';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { Keyboard } from '../components/keyboard';
import { ModalWrap } from '../../../components/modal-wrap';
import getFormatMessage from '../../../locales/get-format-message';
import { memberQuit } from '../../admin/lib/member';
import { messageError } from '../../../components/message';

interface IProps {
  readonly onClose: () => void;
  readonly userInfo: IAPIUserInfo;
}

export const AccountCenter = (props: IProps) => {
  const userDispatch = useDispatch<Dispatch<CommonAction>>();

  const [showDeleteAccountModal, setShowDeleteAccountModal] =
    useState<boolean>(false);
  const [showEditPasswordModal, setShowEditPasswordModal] =
    useState<boolean>(false);

  useEffect(() => {
    const firstElement = document.querySelector(
      '.document-headline'
    ) as HTMLElement;
    if (firstElement) {
      firstElement.style.position = 'fixed';
    }
    getUserInfoContent();
  }, []);

  const getUserInfoContent = async () => {
    const res = await getUserInfo();
    if (res) {
      userDispatch({
        type: ReduxCommonActionType.LOGIN,
        result: res,
      });
    }
  };

  const getUsername = () => {
    return formatEmailName(props.userInfo.UserName || props.userInfo.UserID);
  };

  const renderEditPasswordModal = () => {
    if (showEditPasswordModal) {
      return (
        <EditPasswordModal
          onClose={closeEditPasswordModal}
          username={formatEmailName(getUsername())}
        />
      );
    }
    return null;
  };

  const openEditPasswordModal = () => {
    const accountLeftIcon = document.getElementById(
      'accountLeftIcon'
    ) as HTMLElement;
    if (accountLeftIcon) {
      accountLeftIcon.style.zIndex = '999';
    }
    setShowEditPasswordModal(true);
  };

  const closeEditPasswordModal = () => {
    const accountLeftIcon = document.getElementById(
      'accountLeftIcon'
    ) as HTMLElement;
    if (accountLeftIcon) {
      accountLeftIcon.style.zIndex = '2000';
    }
    setShowEditPasswordModal(false);
  };

  const onDeleteSupportAccount = () => {
    ModalWrap.show({
      title: '删除账户',
      children: '确定不再使用InGame Support控制台吗?',
      async onOk() {
        const res = await memberQuit();
        if (res) {
          window.location.reload();
          return true;
        }

        messageError(getFormatMessage('failed'));
        return false;
      },
      oKText: getFormatMessage('Confirm'),
      cancelText: getFormatMessage('cancel'),
    });
  };

  const renderDeleteModal = () => {
    if (showDeleteAccountModal) {
      return (
        <DeleteAccount
          isShow={showDeleteAccountModal}
          onClose={() => setShowDeleteAccountModal(false)}
        />
      );
    }
    return null;
  };

  if (!props.userInfo) {
    return null;
  }

  return (
    <Keyboard shortcutKeys="escape" onEmit={props.onClose}>
      <div className="positionBox" tabIndex={1}>
        <input autoFocus={true} style={{ opacity: 0 }}></input>
        <div className="accountLeftIcon" id="accountLeftIcon"></div>
        <div className="escBox" onClick={props.onClose}></div>
        <AccountInfo
          userInfo={props.userInfo}
          onEditPassModal={openEditPasswordModal}
          onDeleteAccountModal={() => setShowDeleteAccountModal(true)}
          onDeleteSupportAccount={onDeleteSupportAccount}
          onReload={getUserInfoContent}
          username={getUsername()}
        />
        {renderDeleteModal()}
        {renderEditPasswordModal()}
        <div className="mask-style"></div>
      </div>
    </Keyboard>
  );
};
